module.exports = __webpack_public_path__ + "static/media/building.095859f0.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icons/building.svg
// module id = 264
// module chunks = 0